// Resume Video ***********************************************************************************
// pathname: /v1/resume/video
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface SwrResumeVideoProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch user video cv.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param shouldFetch - { boolean } - a flag indicating whether to start fetching. Default: true
 */
export const useSwrResumeVideo = (props: SwrResumeVideoProps) => {
  // Destructure props
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'ResumeVideoRead'>>({
    url: '/v1/resume/video',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 10 * 1000, // 10 seconds
      revalidateOnFocus: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
